import { Component, OnInit } from '@angular/core';
import { TranslatorService } from './modules/translator/providers/translator.service';
//import { AwlLocaleService } from 'aacom-widgets';
//import { AwlCookieService } from '@aacom-widgets/services';
import { TealiumUtagService } from './tealium/utag.service';
import { AnalyticsHandlerService } from './tealium/analytics-handler';
import {ActivatedRoute, NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  providers: [TealiumUtagService]
})
export class AppComponent implements OnInit {
  title = 'refund-web-ui';

  private locale: string;
  previousLocale: string;
  currentLocale: string;
  showHeaderAndFooter = true;

  constructor(private translatorService: TranslatorService,
    // private localeService: AwlLocaleService,
              private tealium: TealiumUtagService,
              private analyticsHandler: AnalyticsHandlerService,
              private router: Router,
              private route: ActivatedRoute
              //private cookieService: AwlCookieService
            ) {
    this.locale = this.getParameterByName('locale');
    this.loadLocale();
    // localStorage.setItem("locale", this.locale);
    localStorage.setItem('locale', this.currentLocale);
    this.router.events.pipe(filter(event => event instanceof NavigationEnd)).subscribe(event => this.modifyHeader(event));
  }

  ngOnInit(): void {
    // The tealium.view function will call the tealium.track function with 'view' as first param
    // Most tags support the 'view' event and many analytics tags also support the 'link' event
    // this.tealium.view({event_name: 'init'});
    // this.tealium.track("view", { event_name: "prodview", my_key: "my_value", my_products_displayed: ["p1", "p2"] });
    // this.tealium.setConfig({ account: 'aa', profile: 'main', environment: 'dev' });
    this.tealium.setConfig(this.analyticsHandler.getTealiumConfigs());
    // this.tealium.setConfig({ account: 'aa', profile: this.title, environment: 'dev' });
    // this.tealium.track('view', {'event_name' : 'init'});
    this.previousLocale = localStorage.getItem('previousLocale');
    //this.currentLocale = this.cookieService.get('sessionLocale');
    const cookies = document.cookie.split(';');
    let i;
    for (i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].split('=');
      if (cookie[0].trim() === 'sessionLocale') {
        if (this.previousLocale === this.currentLocale &&
          this.previousLocale === cookie[1].trim()) {
          console.log('no change in locale value..');
        } else {
          this.currentLocale = cookie[1];
          break;
        }
      }
    }
    localStorage.setItem('previousLocale', this.currentLocale);
    //console.log('sessionLocale ' + this.cookieService.get('sessionLocale'));
    console.log('previousLocale ' + this.previousLocale);
    this.loadLocale();
  }

  getParameterByName(name: any) {
    const url = window.location.href;
    name = name.replace(/[[]]/g, '$&');
    const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    const results = regex.exec(url);
    if (!results) {
      return null;
    }
    if (!results[2]) {
      return '';
    }
    return decodeURIComponent(results[2].trim());
  }

  private loadLocale() {
    // if (this.locale) {
    //   this.localeService.setLocaleCode(this.locale === 'es' ? 'es_US' : this.locale);
    //   this.translatorService.loadTranslations(this.locale);
    // } else {
      // this.locale = this.localeService.locale.getLocale();
      // this.translatorService.loadTranslations(this.locale);
      this.translatorService.loadTranslations(this.currentLocale);
      localStorage.setItem('locale', this.currentLocale);
      // }
  }

  modifyHeader(location) {
    console.log('URL: ' + location.url);
    if (location.url.includes('/cancelrefund')) {
      const clientId = this.route.snapshot.queryParams['clientId'];
      console.log('Client id: ' + clientId);
      if (clientId === 'RESCOM') {
        this.showHeaderAndFooter = false;
      }
    }
  }

}
